<script lang="ts">
    import type {ModalWindowActions} from '../modals.types';
    import {setModalContext} from './modal-context';

    export let additionalClasses = '';
    export let id: string = null;
    export let modalWindowActions: ModalWindowActions;

    setModalContext(modalWindowActions);
</script>

<div {id} class="kp-modal-content {additionalClasses}">
    <div class="modal-header">
        <slot name="header"></slot>
    </div>

    <div class="modal-body">
        <slot name="body"></slot>
    </div>

    <div class="modal-footer">
        <slot name="footer"></slot>
    </div>
</div>

<style lang="less">
    .modal-body {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
</style>
